import React, { useState, Suspense, lazy } from "react";

const CustomizeStationModal = lazy(() =>
  import(/* webpackChunkName: "cstmzstm" */ "./CustomizeStationModal")
);
import { Grid, Tooltip } from "@material-ui/core";

import LoadingSection from "../parts/LoadingSection";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const CustomizeStation = () => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Grid item id="now-playing-edit-station" className="pr-3 pr-md-4">
      <Tooltip title="Customize Station">
        <div onClick={handleClickOpen}>
          <FontAwesomeIcon icon="edit" className="ml-2 icon-action" />
        </div>
      </Tooltip>
      <Suspense fallback={
        <div className="pr-2">
          <LoadingSection type="loading-icon" />
        </div>
      }>
        {open && <CustomizeStationModal open={open} onClose={handleClose} />}
      </Suspense>
    </Grid>
  );
};

export default CustomizeStation;
